import Carousel from "react-bootstrap/Carousel";

function TinySlider({ array }) {
  console.log("9999999999999999999999", array);
  return (
    <Carousel indicators={false}>
      {array.map((value) => {
        return (
          <Carousel.Item interval={5000}>
            <img
              className="d-block w-100"
              src={`http://ghodsflyb.tatdemo.ir/${value}`}
              alt="First slide"
              style={{
                borderRadius: "12px",
                width: "100%",
                height: "240px",
                objectFit: "contain",
              }}
            />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

export default TinySlider;
